/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import CachingEmoji from '../common/CachingEmoji';
import { emojiItem, emojiPickerRow } from './styles';
import { useEmojiPickerListContext } from '../../hooks/useEmojiPickerListContext';
import { messages } from '../i18n';
var EmojiPickerEmojiRow = function EmojiPickerEmojiRow(_ref) {
  var emojis = _ref.emojis,
    onSelected = _ref.onSelected,
    onMouseMove = _ref.onMouseMove,
    onFocus = _ref.onFocus,
    title = _ref.title,
    showDelete = _ref.showDelete,
    onDelete = _ref.onDelete,
    virtualItemContext = _ref.virtualItemContext;
  var _useEmojiPickerListCo = useEmojiPickerListContext(),
    currentEmojisFocus = _useEmojiPickerListCo.currentEmojisFocus,
    setEmojisFocus = _useEmojiPickerListCo.setEmojisFocus;
  var rowIndex = (virtualItemContext === null || virtualItemContext === void 0 ? void 0 : virtualItemContext.index) || 0;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var handleFocus = function handleFocus(index) {
    return function (emojiId, emoji, event) {
      setEmojisFocus({
        rowIndex: rowIndex,
        columnIndex: index
      });
      onFocus && onFocus(emojiId, emoji, event);
    };
  };
  return jsx("div", {
    css: emojiPickerRow,
    role: "presentation"
  }, emojis.map(function (emoji, index) {
    var shortName = emoji.shortName,
      id = emoji.id;
    var key = id ? "".concat(id, "-").concat(title) : "".concat(shortName, "-").concat(title);
    var focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
    return jsx("span", {
      css: emojiItem,
      key: key,
      role: "gridcell",
      "aria-colindex": index + 1 // aria-colindex is 1 based
    }, jsx(CachingEmoji, {
      emoji: emoji,
      selectOnHover: true,
      onSelected: onSelected,
      onMouseMove: onMouseMove,
      onFocus: handleFocus(index),
      showDelete: showDelete,
      onDelete: onDelete,
      placeholderSize: 24,
      "data-focus-index": "".concat(rowIndex, "-").concat(index),
      tabIndex: focus ? 0 : -1,
      "aria-roledescription": formatMessage(messages.emojiButtonRoleDescription),
      shouldBeInteractive: true
    }));
  }));
};
export default /*#__PURE__*/memo(EmojiPickerEmojiRow);